import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { REJECT_REASON } from 'domains/seller-rejected-product/constants'

const proptypes = {
  reject_reason: PropTypes.string
}

/**
 * To give nice look on Tinkerlust Reject Reason.
 * It maps `reject_reason` to certain style and pass to `StatusBadge`.
 * @param {string} reject_reason - reject reason. Available values see `domains/seller-rejected-product/constants/seller-rejected-product-constant.js`
 */
const SellerRejectedProductRejectReasonBadge = ({ reject_reason }) => {

  const colorMap = REJECT_REASON[reject_reason] || 'default'

  return (
    <StatusBadge color={ colorMap } label={ reject_reason } />
  )
}

SellerRejectedProductRejectReasonBadge.propTypes = proptypes

export default SellerRejectedProductRejectReasonBadge
